/* eslint-disable jsx-a11y/no-static-element-interactions, jsx-a11y/anchor-is-valid */

import React from 'react';
import { PropTypes } from 'prop-types';
import { Link } from 'react-router-dom';
import ProfileImage from 'components/ProfileImage/ProfileImage';
import { paths, profile } from 'constants';
import { track } from 'utils/koala-analytics';
import { Trans } from 'react-i18next';

const propTypes = {
  title: PropTypes.string,
  first: PropTypes.string,
  last: PropTypes.string,
  imageFile: PropTypes.string,
};

const defaultProps = {
  title: undefined,
  first: undefined,
  last: undefined,
  imageFile: undefined,
};

const trackEditPhoto = () => {
  const trackingData = {
    event: 'link click',
    subtype: 'hyperlink',
    page_section: 'personal details > photo',
    event_value: 'edit',
  };
  track(trackingData);
};

const trackEditName = () => {
  const trackingData = {
    event: 'link click',
    subtype: 'hyperlink',
    page_section: 'personal details > name',
    event_value: 'edit',
  };
  track(trackingData);
};

const Name = props => (
  <section className="details-block name">
    <div className="jg-space-phsm@sm jg-space-phn@lg">
      <div className="name__avatar jg-icon--profile">
        <ProfileImage imageFile={props.imageFile} />
        <br />
        <a
          onClick={() => {
            trackEditPhoto();
            window.location.href = `${profile.baseUrl}/${profile.urlSuffix}`;
          }}
          className="qa-link__profile-image"
          style={{ cursor: 'pointer' }}
        >
          <Trans i18nKey="personalDetails.edit">Edit</Trans>
        </a>
      </div>
      <div className="name__details jg-space-mtsm">
        <p className="jg-text--medium-regular">
          <Trans i18nKey="personalDetails.name">Name</Trans>
        </p>
        <p>
          <span className="data-value">
            {props.title === 'Other' ? '' : props.title} {props.first}{' '}
            {props.last}
          </span>
          <Link
            to={paths.Name}
            onClick={trackEditName}
            className="jg-edit-link qa-link__name-and-title jg-space-mlsm"
          >
            <Trans i18nKey="personalDetails.edit">Edit</Trans>
          </Link>
        </p>
      </div>
    </div>
  </section>
);

Name.propTypes = propTypes;

Name.defaultProps = defaultProps;

export default Name;
